$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');

  function updateText() {
    if ($(window).width() < 801) {
      $('a.ticket').text('Get Tickets');
    } else {
      $('a.ticket').text('Tickets!');
    }
  }

  updateText(); // Initial update

  $(window).on('resize', function() {
    updateText();
  });

  // Popup Placeholder Replace

  const $popupInput = $('.hive-signup-form');

  $popupInput.find('#_HIVE-email-4875').attr('placeholder', 'Email:');
  $popupInput.find('#_HIVE-firstName-4875').attr('placeholder', 'First:');
  $popupInput.find('#_HIVE-lastName-4875').attr('placeholder', 'Last:');

});

$(window).load(function () {
  // ---

});